<template>
  <div id="MaterialProcurementContract"  v-loading="loading">
    <div class="buttons"  v-loading="loading">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="PrintContractB"
        style="margin: 10px 0"
        >打印</el-button
      ><el-button
        type="primary"
        icon="el-icon-plus"
        @click="saveContractA"
        style="margin: 10px 10px"
        v-if="dialogForm.approveStatus != 3 && dialogForm.approveStatus != 2"
        >保存
      </el-button>
      <el-button type="primary" @click="setWatermark" style="margin: 10px 0"
        >设置水印
      </el-button>
      <div style="display: inline-flex; width: 300px;margin-left:150px;">
        <el-input v-model="inputPages" placeholder="总页数" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputHeight" placeholder="单页高" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputPosx" placeholder="偏移量" style="margin-left: 10px;"></el-input>
      </div>
    </div>
    <div
      ref="HTMLMaterialContent"
      id="HTMLMaterialContent"
      :class="printClass"
      :key="printClass"
    >
      <div class="HTMLMaterialContent1" id="HTMLMaterialContent1">
        <div style="position: relative">
          <p style="text-align: right; font-size: 14px">
            <span
              style="
                position: absolute;
                z-index: 8;
                left: 10px;
                top: 10px;
                width: 44px;
                height: 57px;
              "
              ><img
                width="44"
                height="57"
                src="../../../assets/images/subContract/LaborContract/logo.png"
                alt="路桥logo" /></span
            ><span style="font-size: 20px; font-family: 宋体; color: red"
              >N</span
            ><span style="font-size: 20px; font-family: 宋体; color: red"
              >O</span
            ><span style="font-size: 20px; font-family: 宋体; color: red"
              >：{{ dialogForm.flowNo || "" }}</span
            >
          </p>
        </div>
        <p style="text-align: right; font-size: 14px">
          <span style="font-size: 20px; font-family: 宋体">&nbsp;</span>
          <span style="font-size: 20px; font-family: 宋体">合同编号：</span>
          <span
            style="
              outline: 0;
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              display: inline-block;
              min-width: 6cm;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="serialNumber"
          >
            {{ detailForm.serialNumber }}</span
          >
        </p>
        <p style="text-align: right; font-size: 14px">
          <span>
            <span style="font-size: 20px; font-family: 宋体"> &nbsp; </span>
          </span>
        </p>
        <p style="text-align: right; font-size: 14px">
          <span
            ><span style="font-size: 20px; font-family: 宋体"
              >&nbsp;</span
            ></span
          >
        </p>
        <p style="text-align: right; font-size: 14px">
          <span
            ><span style="font-size: 20px; font-family: 宋体"
              >&nbsp;</span
            ></span
          >
        </p>
        <p style="text-align: center; font-size: 14px">
          <span
            style="font-size:56px; font-family: &#39;锐字云字库小标宋体1.0&#39;;letter-spacing: 2px; font-weight: bold;"
            >物资采购合同</span
          >
        </p>
        <p style="text-align: justify; font-size: 14px">
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p style="text-align: justify; font-size: 14px">
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p style="text-align: justify; font-size: 14px">
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p style="text-align: justify; font-size: 14px">
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p style="text-align: justify; font-size: 14px">
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p style="text-align: justify; font-size: 14px">
          <span style="font-family: 宋体">&nbsp;</span>
        </p>
        <p
          style="
            font-size: 14px;
            text-align: justify;
            text-indent: 21px;
            line-height: 56px;
          "
        >
          <strong>
            <span style="font-size: 21px; font-family: 宋体; font-weight: 600">
              甲&nbsp;&nbsp;方：
              <span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  text-indent: 5px;
                  display: inline-block;
                  min-width: 14cm;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="partyA"
                >{{ detailForm.partyA ? detailForm.partyA : "" }}
              </span>
            </span>
          </strong>
        </p>
        <p
          style="
            font-size: 14px;
            text-align: justify;
            text-indent: 21px;
            line-height: 56px;
            margin-bottom: 6px;
          "
        >
          <strong>
            <span style="font-size: 21px; font-family: 宋体; font-weight: 600">
              乙&nbsp;&nbsp;方：
              <span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  min-width: 14cm;
                  display: inline-block;
                  text-indent: 5px;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="partyB"
                >{{ detailForm.partyB ? detailForm.partyB : "" }}
              </span>
            </span>
          </strong>
        </p>
        <div
          style="
            display: flex;
            font-size: 21px;
            font-family: 宋体;
            font-weight: 600;
            line-height: 70px;
          "
        >
          <div style="text-indent: 21px">项目名称：</div>
          <div style="width: 14.2cm; margin-left: 10px">
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                padding-bottom: 20px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="projectName"
              >{{ detailForm.projectName ? detailForm.projectName : "" }}</span
            >
          </div>
        </div>
        <!-- <p
          style="
            font-size: 14px;
            text-align: justify;
            text-indent: 21px;
            line-height: 56px;
          "
        >
          <strong>
            <span style="font-size: 21px; font-family: 宋体; font-weight: 600">
              项目名称：
              <span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  min-width: 14cm;
                  width: 14cm;
                  text-indent: 5px;
                  padding-bottom:20px;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="projectName"
                >{{ detailForm.projectName ? detailForm.projectName : "" }}
              </span>
            </span>
          </strong>
        </p> -->
        <p
          style="
            font-size: 14px;
            text-align: justify;
            text-indent: 21px;
            line-height: 56px;
          "
        >
          <strong
            ><span style="font-size: 21px; font-family: 宋体; font-weight: 600"
              >签订地点：
              <span
                style="
                  border-bottom: 1px solid rgb(44, 62, 80);
                  outline: 0;
                  min-width: 14cm;
                  display: inline-block;
                  text-indent: 5px;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                class="signPlace"
                >{{ detailForm.signPlace ? detailForm.signPlace : "" }}</span
              ></span
            ></strong
          >
        </p>
        <p style="font-size: 14px; text-align: justify; text-indent: 21px">
          <span style="font-size: 21px; font-family: 宋体"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          >
        </p>
        <!--      <p style=";font-size: 14px;text-align: justify"><span style="font-size: 21px;font-family: 宋体">&nbsp;</span></p>-->
        <p
          style="
            font-size: 14px;
            text-align: center;
            vertical-align: middle;
            outline: 0;
          "
        >
          <span
            style="font-size: 21px; font-family: 宋体;outline: 0;"
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="signDate"
            >{{ detailForm.signDate ? detailForm.signDate : " - - " }}</span
          >
        </p>
        <p
          style="
            text-align: center;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
            page-break-before: always;
          "
        >
          <strong
            ><span style="font-size: 24px; font-family: 黑体; font-weight: bold"
              >建设工程物资采购合同</span
            ></strong
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">
            合同编号：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              >{{
                detailForm.serialNumber ? detailForm.serialNumber : ""
              }}</span
            >
          </span>
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >签订时间：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="signDate1"
              >{{
                detailForm.signDate1
                  ? detailForm.signDate1
                  : detailForm.signDate
              }}</span
            >
            <!--          年<span-->
            <!--            style="text-decoration:underline;" :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3">&nbsp; </span>月<span-->
            <!--            style="text-decoration:underline;" :contenteditable="dialogForm.approveStatus != 2&&dialogForm.approveStatus != 3">&nbsp; </span>日-->
          </span>
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >签约地点：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="signPlace1"
              >{{ detailForm.signPlace1 }}</span
            ></span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">
            需 <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>方：
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              >{{ detailForm.partyA ? detailForm.partyA : ""
              }}<span style="float: right; margin-right: -10px"
                >（甲方）</span
              ></span
            >
          </span>
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">
            供<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>方：
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              >{{ detailForm.partyB ? detailForm.partyB : ""
              }}<span style="float: right; margin-right: -10px">（乙方）</span>
            </span>
          </span>
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >根据《中华人民共和国民法典》及有关法律法规的规定，遵循平等、自愿和诚实信用的原则，双方就需方<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 4cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="project"
              >{{ detailForm.project }}</span
            >工程<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 4cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="projectTip"
              >{{ detailForm.projectTip }}</span
            >的购销事项协商一致，根据各工程的具体情况，订立以下合同条款：</span
          >
        </p>
        <p
          style="
            margin: 0 0 0 32px;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-size: 19px;
                font-family: 楷体_GB2312;
                font-weight: bold;
              "
              >第一条 标的、价款等</span
            ></strong
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">1.1 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >材料规格及单价</span
          >
        </p>
        <table
          ref="onlyPriceTable"
          width="100%"
          style="border-collapse: collapse; border-width: 1px"
          :key="tableKey"
        >
          <thead style="display: table-header-group">
            <tr style="min-height: 31px" class="firstRow">
              <td
                width="48"
                style="
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  padding: 0px 7px;
                "
              >
                <p
                  style="text-align: center; font-size: 14px; line-height: 31px"
                >
                  <span style="font-family: 楷体_GB2312">序号</span>
                </p>
              </td>
              <td
                width="113"
                style="
                  border-style: solid;
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left: 0;
                  padding: 0px 7px;
                "
              >
                <p
                  style="text-align: center; font-size: 14px; line-height: 31px"
                >
                  <span style="font-family: 楷体_GB2312">材料名称</span>
                </p>
              </td>
              <td
                width="72"
                style="
                  border-style: solid;
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left: 0;
                  padding: 0px 7px;
                "
              >
                <p
                  style="text-align: center; font-size: 14px; line-height: 31px"
                >
                  <span style="font-family: 楷体_GB2312">规格型号</span>
                </p>
              </td>
              <td
                width="48"
                style="
                  border-style: solid;
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left: 0;
                  padding: 0px 7px;
                "
              >
                <p
                  style="text-align: center; font-size: 14px; line-height: 31px"
                >
                  <span style="font-family: 楷体_GB2312">单位</span>
                </p>
              </td>
              <td
                width="79"
                style="
                  border-style: solid;
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left: 0;
                  padding: 0px 7px;
                "
              >
                <p
                  style="
                    text-align: center;
                    font-size: 14px;
                    line-height: 24px;
                    margin-bottom: 0;
                  "
                >
                  <span style="font-family: 楷体_GB2312">不含税</span>
                </p>
                <p
                  style="
                    text-align: center;
                    font-size: 14px;
                    line-height: 24px;
                    margin-top: 0;
                  "
                >
                  <span style="font-family: 楷体_GB2312">单价（元）</span>
                </p>
              </td>
              <td
                width="47"
                style="
                  border-style: solid;
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left: 0;
                  padding: 0px 7px;
                "
              >
                <p
                  style="text-align: center; font-size: 14px; line-height: 31px"
                >
                  <span style="font-family: 楷体_GB2312">税率</span>
                </p>
              </td>
              <td
                width="72"
                style="
                  border-style: solid;
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left: 0;
                  padding: 0px 7px;
                "
              >
                <p
                  style="
                    text-align: center;
                    font-size: 14px;
                    line-height: 24px;
                    margin-bottom: 0;
                  "
                >
                  <span style="font-family: 楷体_GB2312">含税</span>
                </p>
                <p
                  style="
                    text-align: center;
                    font-size: 14px;
                    line-height: 24px;
                    margin-top: 0;
                  "
                >
                  <span style="font-family: 楷体_GB2312">单价（元）</span>
                </p>
              </td>
              <td
                width="103"
                style="
                  border-style: solid;
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left: 0;
                  padding: 0px 7px;
                "
              >
                <p
                  style="text-align: center; font-size: 14px; line-height: 31px"
                >
                  <span style="font-family: 楷体_GB2312">质量标准</span>
                </p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              style="height: 35px; page-break-inside: avoid"
              v-for="item in totalPricetableList"
              :key="item.id"
            >
              <td
                width="48"
                style="
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-top-width: 0;
                  padding: 2px 7px;
                  border-style: solid;
                  outline: 0;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                <!-- <input v-model="item.id"/> -->
                {{ item.column0 }}
              </td>
              <td
                width="142"
                style="
                  border-top-width: 0;
                  border-left-width: 1px;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  padding: 2px 7px;
                  border-style: solid;
                  outline: 0;
                "
                :style="
                  item.column1.includes('暂定') ? 'line-height:31px;' : ''
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column1 }}
              </td>
              <td
                width="62"
                style="
                  border-top-width: 0;
                  border-left: 0;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  padding: 2px 7px;
                  border-style: solid;
                  outline: 0;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column2 }}
              </td>
              <td
                width="48"
                style="
                  border-top: 0;
                  border-left: 0;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  padding: 2px 7px;
                  border-style: solid;
                  outline: 0;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column3 }}
              </td>
              <td
                width="58"
                style="
                  border-top: 0;
                  border-left: 0;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  padding: 2px 7px;
                  border-style: solid;
                  outline: 0;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column4 }}
              </td>
              <td
                width="57"
                style="
                  border-top: 0;
                  border-left: 0;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  padding: 2px 7px;
                  border-style: solid;
                  outline: 0;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column5 }}
              </td>
              <td
                width="104"
                style="
                  border-top: 0;
                  border-left: 0;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  padding: 2px 7px;
                  border-style: solid;
                  outline: 0;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column6 }}
              </td>
              <td
                width="81"
                style="
                  border-top: 0;
                  border-left: 0;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  padding: 2px 7px;
                  border-style: solid;
                  outline: 0;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column7 }}
              </td>
            </tr>
          </tbody>
        </table>
        <div
          style="display: flex"
          v-if="dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3"
        >
          <el-tooltip
            class="item"
            effect="dark"
            content="添加行"
            placement="top-start"
          >
            <i class="el-icon-plus" @click="addItem"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除行"
            placement="top-start"
          >
            <i class="el-icon-minus" @click="delItem"></i>
          </el-tooltip>
        </div>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >1.2 合同单价及总价</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >产品单价以本合同第一条第1.1项表格中的约定为准，合同有效期内单价固定不变。合同总价为施工现场实际所用产品总价，即合同总价=单价×产品数量（最终数量以双方签字确认的结算单为准），
            该价款是供方完成本合同义务后，需方支付给供方的全部价款，此价款含运费、卸车费、税费（税率以供方开具发票时国家规定税率为准，税金随着税率调整而调整。）、检测等费用，除此外甲方无需支付其他费用。在供料期间供方服从需方调度和材料进场计划安排。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 19px;
            white-space: normal;
            text-indent: 41px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">1.3</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >不含税单价固定不变，税金随着国家规定税率的调整而调整，最终税金金额以开具发票时的国家税率计算为准。</span
          >
        </p>
        <p
          style="
            font-size: 19px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
            font-family: 楷体_GB2312;
          "
        >
          <span style="display: inline-block; float: left; margin-right: -38px"
            >1.4
          </span>
          <span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              word-break: break-all;
              padding-bottom: 2px;
              line-height: 32px;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="addItems1"
            >{{ detailForm.addItems1 || "无" }}</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 19px;
            white-space: normal;
            text-indent: 32px;
            line-height: 31px;
          "
        >
          <strong
            ><span style="font-family: 楷体_GB2312; font-weight: bold"
              >第二条 质量标准：</span
            ></strong
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 19px;
            white-space: normal;
            text-indent: 41px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">2.1</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >供方供应的产品质量必须符合国家标准
            (工程设计有特殊要求时应符合工程设计的质量等级要求) </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >并提供相应产品质量证明书</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >。各项技术性能指标经<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 8cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="jainyan"
              >{{ detailForm.jainyan }}</span
            >检验必需合格。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">2.2 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >等级要求： 满足优等品要求。</span
          >
        </p>
        <p
          style="
            font-size: 19px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span
            style="
              font-family: 楷体_GB2312;
              display: inline-block;
              float: left;
              margin-right: -38px;
            "
            >2.3 满足需方的材料要求：</span
          >
          <span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              min-width: 11cm;
              font-family: 楷体_GB2312;
              word-break: break-all;
              padding-bottom: 2px;
              line-height: 32px;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="matrailsNeed1"
            >{{ detailForm.matrailsNeed1 || "无" }}</span
          >
        </p>
        <p
          style="
            font-size: 19px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-family: 楷体_GB2312;
                display: inline-block;
                float: left;
                font-weight: bold;
                display: inline-block;
                float: left;
                margin-right: -38px;
              "
              >第三条 供方对质量负责的条件及期限：</span
            ></strong
          >
          <span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              min-width: 8.2cm;
              font-family: 楷体_GB2312;
              word-break: break-all;
              padding-bottom: 2px;
              line-height: 32px;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="contidion1"
            >{{ detailForm.contidion1 || "无" }}</span
          >
        </p>

        <p
          style="
            font-size: 19px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span style="font-family: 楷体_GB2312; font-weight: bold"
              >第四条 包装标准、包装物的供应与回收：</span
            ></strong
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >供方提供的产品包装必须牢固，供方应保障商品在运输途中的安全。需方对商品包装有特殊要求，双方应在合同中注明，增加的包装费用由需方负担。</span
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >产品的包装，国家或是业务部门有技术规定的，按技术规定执行；国家或是业务部门无技术规定的，由供需双方协商确定。产品的包装物，除国家规定由需方供应以外，应由供方负责供应。</span
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-size: 19px;
                font-family: 楷体_GB2312;
                font-weight: bold;
              "
              >第五条
              随货的必备品、配件、工具数量及供应办法：随货带产品合格证、质保书、检测报告等技术资料原件。</span
            ></strong
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-size: 19px;
                font-family: 楷体_GB2312;
                font-weight: bold;
              "
              >第六条 合理损耗标准及计算方法：
              不计损耗&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
            ></strong
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-size: 19px;
                font-family: 楷体_GB2312;
                font-weight: bold;
              "
              >第七条</span
            ></strong
          ><span style="font-size: 19px; font-family: 楷体_GB2312">
            标的物所有权自<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 4cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="zysj"
              >{{ detailForm.zysj }}</span
            >时起转移，但经验收确认为不合格的，供方必须根据需方要求无条件退换。</span
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-size: 19px;
                font-family: 楷体_GB2312;
                font-weight: bold;
              "
              >第八条 交（提）货方式、时间、地点：</span
            ></strong
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">8.1 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >供货时间：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 8cm;
                white-space: pre-wrap;
                text-overflow: ellipsis;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="ghsj"
              >{{ detailForm.ghsj }}</span
            ></span
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">8.2 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >送货至<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 8cm;
                white-space: pre-wrap;
                text-overflow: ellipsis;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="xmssxc"
              >{{ detailForm.xmssxc }}</span
            >项目施工现场需方指定地点，经供、需、劳务分包三方共同验收，三方应共同在验收单上签字。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">8.3 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312">供方</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >送货人员必须遵守需方施工现场的安全规定和需方</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >有关要求</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >，装卸车过程必须听从需方现场人员的指挥及安排，否则，一切后果与损失及由此产生的连带责任由供方承担。</span
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-size: 19px;
                font-family: 楷体_GB2312;
                font-weight: bold;
              "
              >第九条 运输方式及到达站（港）和费用负担</span
            ></strong
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >：标的物在运输过程中所产生的一切运费、人工费、装卸费由供方承担，在运输过程中造成的一切损失均由供方自行承担。供应单位引起的污染环境和道路的处罚由供方负全部责任。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-size: 19px;
                font-family: 楷体_GB2312;
                font-weight: bold;
              "
              >第十条 检验标准、方法、地点及提出异议的形式与期限：</span
            ></strong
          >
        </p>
        <p
          style="
            margin: 0 0 0 32px;
            font-size: 19px;
            white-space: normal;
            line-height: 31px;
          "
        >
          <span
            style="font-family: 楷体_GB2312; display: inline-block; float: left"
            >10.1 数量验收： </span
          ><span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              min-width: 13.3cm;
              font-family: 楷体_GB2312;
              padding-bottom: 2px;
              line-height: 32px;
              word-break: break-all;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="slys1"
            >{{ detailForm.slys1 || "无" }}</span
          >
        </p>

        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">10.2 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >质量验收：⑴
            进行数量验收的同时，进行外观质量验收（以供方提供的样品为准）。外观质量符合合同要求的方可卸车，否则不得卸车。⑵对外观质量符合合同要求的，各项性能指标符合要求作为最终验收结论。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">10.3 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >供方对所供材料的质量、规格、要求和标准均是供方应该做到的和应尽的义务，同样是供方向需方的承诺，无条件的遵守。无条件的服从和执行需方、业主、监理公司所提出的材料质量、规格等缺陷，并做到对方满意。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">10.4 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >需方在验收中如发现货物的品种、型号、规格和质量不合规定或约定，应在妥善保管货物的同时，自收到货物后<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 1cm;
                white-space: pre-wrap;
                text-overflow: ellipsis;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="timeAfterGet"
              >{{ detailForm.timeAfterGet }} </span
            >日内向供方提出书面异议；在异议期间，需方有权拒付不符合合同规定部分的货款。&nbsp;&nbsp;&nbsp;</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >供方在接到需方书面异议后，应在<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 1cm;
                white-space: pre-wrap;
                text-overflow: ellipsis;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="timeHandle"
              >{{ detailForm.timeHandle }}</span
            >日内负责处理并通知需方处理情况，否则，即视为默认需方提出的异议和处理意见。&nbsp;&nbsp;&nbsp;</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 19px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span
            style="
              font-family: 楷体_GB2312;
              display: inline-block;
              float: left;
              margin-right: -30px;
            "
            >10.5 其它</span
          ><span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              min-width: 14.2cm;
              white-space: pre-wrap;
              text-overflow: ellipsis;
              padding-bottom: 2px;
              line-height: 32px;
              word-break: break-all;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="others"
            >{{ detailForm.others || "无" }}</span
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-size: 19px;
                font-family: 楷体_GB2312;
                font-weight: bold;
              "
              >第十一条 结算及付款方式：</span
            ></strong
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">11.1 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >供方按照本合同约定及需方的要求交付货物完毕，经需方验收合格后，需方才向供方结算合同价款。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">11.2 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >结算数量确认：货物数量以双方签字确认的结算单为准。</span
          >
        </p>

        <p
          style="
            text-align: justify;
            font-size: 19px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span
            style="
              font-family: 楷体_GB2312;
              display: inline-block;
              float: left;
              margin-right: -38px;
            "
            >11.3 付款：</span
          >
          <span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              min-width: 14.2cm;
              font-family: 楷体_GB2312;
              padding-bottom: 2px;
              line-height: 32px;
              word-break: break-all;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="fk1"
            >{{ detailForm.fk1 || "无" }}</span
          >
        </p>

        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">11.4 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >供方必须指派专人到需方收款,同时收款前应向需方出具</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >（符合路桥集团财务审计部要求的）合格的等额发票，否则需方有权拒绝付款直至供方提供合格发票，（税率以供方开具发票时国家规定税率为准，税金随着税率调整而调整）。并供方指派的专人应在第一次收取款项时，必须持与本合同供方单位名称一致的授权收款委托书交需方财务备案；如被授权收款人有变动，则由供方单位重新开具变更授权收款委托书交需方财务备案，否则，需方不予付款。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >需方不与供方其他人员发生任何经济往来，如非被授权收款人员向需方索要货款造成不良事件发生，供方承担由此给需方带来的一切法律责任和经济赔偿。</span
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-size: 19px;
                font-family: 楷体_GB2312;
                font-weight: bold;
              "
              >第十二条 担保方式（也可另立担保合同）：</span
            ></strong
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >双方同意选择按照以下<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                font-weight: bold;
                text-indent: 5px;
                display: inline-block;
                min-width: 1cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="dbfs"
              >{{ detailForm.dbfs }}</span
            >方式提供担保。</span
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">a </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >现金担保</span
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">b </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312">抵押</span>
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">c </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312">质押</span>
        </p>
        <p
          style="
            font-size: 19px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
            font-family: 楷体_GB2312;
          "
        >
          <span style="display: inline-block; float: left; margin-right: -45px"
            >d 其他：</span
          ><span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              display: inline-block;
              min-width: 10cm;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="others1"
            >{{ detailForm.others1 }}</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-size: 19px;
                font-family: 楷体_GB2312;
                font-weight: bold;
              "
              >第十三条 售后服务及质保要求：</span
            ></strong
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >保证产品为合格产品，使用过程中如因产品问题影响施工，供货方保证随叫随到，并派技术人员24小时内到现场，解决产品在施工中的问题。因产品质量问题产生的工程质量缺陷，供方需承担连带责任。</span
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-size: 19px;
                font-family: 楷体_GB2312;
                font-weight: bold;
              "
              >第十四条 违约责任：</span
            ></strong
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 19px;
            white-space: normal;
            text-indent: 42px;
            line-height: 31px;
            font-family: 楷体_GB2312;
          "
        >
          <span>14.1 </span><span>外观及检验不合格的物资，</span
          ><span>供方应在接到需方通知后</span
          ><span
            style="
              border-bottom: 1px solid rgb(44, 62, 80);
              outline: 0;
              text-indent: 5px;
              display: inline-block;
              min-width: 1cm;
            "
            :contenteditable="
              dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
            "
            class="days"
            >{{ detailForm.days }}</span
          ><span
            >日内清理出施工现场，逾期清理的需方有权自行清理，供方应承担清理费用及给需方造成的损失，清理过程中造成物资的损毁，需方无需承担责任。造成的一切损失由供方承担。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">14.2 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >供方日供应量需满足我方施工进度用量，</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312">如</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >供方不按期供货，需方马上通知供方来现场处理，双方核实因工程进度而造成的损失，此损失全部由供方承担。不按期供货超过<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 1cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="expenddays"
              >{{ detailForm.expenddays }}</span
            >日，需方有权寻找其他供方进行供货，造成的差价损失及工程进度损失均由供方承担。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">14.3 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >合同签订前，供方向需方提供一套完整的供方企业资质，若该供方企业不具备承担本合同所明确的生产、经营资质，或合同签订后发现该企业已被工程所在地政府建管部门取消和限制在当地生产、经营等违法、违规现象，需方有权解除合同，供方应承担全部的行政和法律后果，若给需方造成损失的，应承担相应的损害赔偿责任且履约保证金不予返还。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">14.4 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >供方单位若发生企业变更、注册地址以及通信地址变更，必须向需方提供企业变更后的相关材料，否则，供需双方发生纠纷，由供方承担全部法律责任。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">14.5 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >供方提供的物资不符合需方的材料要求、不符合国家和行业标准的，供方应在需方要求后三日内重新提供符合要求的物资，供方逾期提供的，需方有权解除合同并从其他供方处采购符合要求的物资，供方除应承担采购费用外履约保证金不予返还。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">14.6 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >其他因供方原因给需方造成的一切损失，均由供方承担。需方有权从尚未支付的合同价款中扣除，不足的部分，可以要求供方赔偿。</span
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-size: 19px;
                font-family: 楷体_GB2312;
                font-weight: bold;
              "
              >第十五条 合同争议的解决方式：</span
            ></strong
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >本合同的解释和执行适用中华人民共和国法律。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >本合同在履行过程中发生的争议，由双方当事人坦诚友好协商解决；也可由需方当地工商行政管理部门调解,
            如果协商或者调解不能解决，应向签约地点所在地法院提起诉讼。因解决争议而产生的所有费用，包括但不限于诉讼费、律师费、评估费、鉴定费、审计费、差旅费等均由供方承担。</span
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-size: 19px;
                font-family: 楷体_GB2312;
                font-weight: bold;
              "
              >第十六条 本合同解除的条件：</span
            ></strong
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >按《民法典》有关条款执行。</span
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-size: 19px;
                font-family: 楷体_GB2312;
                font-weight: bold;
              "
              >第十七条</span
            ></strong
          ><span style="font-size: 19px; font-family: 楷体_GB2312">
            本合同经供需双方企业法定代表人或委托代理人签字并加盖合同专用章后，方能生效。&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span
          >
        </p>
        <p
          style="
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-size: 19px;
                font-family: 楷体_GB2312;
                font-weight: bold;
              "
              >第十八条 合同份数：</span
            ></strong
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >本合同共<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 1cm;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractHoleNums"
              >{{ detailForm.contractHoleNums }} </span
            >份，需方执<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractAnum"
              >{{ detailForm.contractAnum }}</span
            >份，供方执<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                min-width: 1cm;
                display: inline-block;
                text-indent: 5px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="contractBnum"
              >{{ detailForm.contractBnum }}</span
            >份, 具同等法律效力。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <strong
            ><span
              style="
                font-size: 19px;
                font-family: 楷体_GB2312;
                font-weight: bold;
              "
              >第十九条 其他约定事项：</span
            ></strong
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 32px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">19.1 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >供方必须及时安排好车辆在需方规定的时间把材料送达施工工地并码放整齐。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">19.2 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >材料到场时，供方应该提供每批到场材料的合格证、检验报告等相关材质证明。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">19.3 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >供方对装卸工人必须在家进行安全教育或安全交底后，佩戴好安全防护用品方可进入施工工地。进入施工工地后，送货人员必须听从现场管理人员的指挥，严禁送货及装卸人员在施工现场随意穿行，严禁送货车辆随意停靠，堵塞现场交通要道。如因送货人员不听从现场管理人员的管理而出现安全事故，其责任由供方全部承担，需方不承担连带责任。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">19.4 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >供需双方间的债权、债务，在未达成一致的前提下，均不得以任何方式转让给第三方。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">19.5 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >本合同未涉及的条款，双方可签订补充协议，但须经供需双方企业法定代表人或委托代理人签字并加盖合同专用章后，方能生效,</span
          >
          <span style="font-size: 20px; font-family: 宋体">补充</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312">协议</span
          ><span style="font-size: 20px; font-family: 宋体">规定</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >与本合同具有同等效力。&nbsp;&nbsp;</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">19.6 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >其他未尽事宜，双方友好协商解决。</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">19.7 </span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >特别条款:</span
          >
        </p>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            text-indent: 37px;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312"
            >供方每次收取材料款时，需出具符合需方要求的合法的等额发票给需方，否则，需方不予付款</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >或追回已付款</span
          ><span style="font-size: 19px; font-family: 楷体_GB2312"
            >。如供方提供给需方的发票被税务部门查证为假发票，供方除承担行政罚款、民事责任、刑事犯罪等一切责任外，还须向需方支付不低于涉案发票金额20%的违约金，同时向需方重新提供税务部门出具的合法发票。</span
          >
        </p>
        <p style="font-size: 14px; white-space: normal; line-height: 31px">
          <span style="font-size: 19px; font-family: 楷体_GB2312">&nbsp;</span>
        </p>
        <p
          style="
            margin: 0 0 0 32px;
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">&nbsp;</span>
        </p>
        <table width="100%" style="border-collapse: collapse">
          <tbody>
            <tr
              style="height: 100px; page-break-inside: avoid"
              class="firstRow"
            >
              <td
                width="284"
                style="
                  border-width: 1px;
                  border-color: windowtext;
                  padding: 2px 7px;
                  border-style: solid;
                "
              >
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >供 方：（公 章）：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_gongzhang"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_gongzhang }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >授权委托人（签字）：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_sign"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_sign }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 19px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px">电话：</span>
                  <span
                    class="partA_phone"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_phone }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >账户信息：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_account"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_account }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >&nbsp;</span
                  ><span style="text-decoration: underline"></span>
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >通信地址：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_ads"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_ads }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >传真：</span
                  ><span
                    style="font-size: 19px"
                    class="partA_fix"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partA_fix }}</span
                  >
                </p>
              </td>
              <td
                width="285"
                style="
                  border-top-width: 1px;
                  border-top-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                  border-left: 0;
                  padding: 2px 7px;
                  border-style: solid;
                "
              >
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >需 方（公 章）：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_gongzhang"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_gongzhang }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >授权委托人（签字）：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_sign"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_sign }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 19px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px">电话：</span>
                  <span
                    class="partB_phone"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_phone }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >&nbsp;</span
                  ><span style="text-decoration: underline"></span>
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >&nbsp;</span
                  ><span style="font-size: 19px"></span>
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >通讯地址：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_ads"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_ads }}</span
                  >
                </p>
                <p
                  style="
                    text-align: justify;
                    font-size: 14px;
                    line-height: 31px;
                  "
                >
                  <span style="font-size: 19px; font-family: 楷体_GB2312"
                    >传真：</span
                  ><span
                    style="font-size: 19px"
                    class="partB_fix"
                    :contenteditable="
                      dialogForm.approveStatus != 2 &&
                      dialogForm.approveStatus != 3
                    "
                    >{{ detailForm.partB_fix }}</span
                  >
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p
          style="
            text-align: justify;
            font-size: 14px;
            white-space: normal;
            line-height: 31px;
          "
        >
          <span style="font-size: 19px; font-family: 楷体_GB2312">&nbsp;</span>
        </p>
        <p><br /></p>
      </div>
    </div>
    <div class="printWrap" v-show="false">
      <div
        v-html="materialcontent"
        class="mainHtml"
        id="printMaterialcontent"
      ></div>
    </div>

    <setWatermarkDialog
      ref="setWatermarking"
      @setWaterMarkFun="setWaterMarkFun"
    ></setWatermarkDialog>
  </div>
</template>

<script>
import {
  getServiceContractDetailService, //获取合同填充内容
} from "@/services/allContractServices";
import printJS from "print-js";
import { mixins } from "@/page/contract/template/mixin.js";
import setWatermarkDialog from "../commonCell/setWatermarkDialog.vue";
import { addPageNum, getTableData } from "./common.js";
import { addPageNumCustom } from "./common.js";

export default {
  name: "MaterialProcurementContract",
  mixins: [mixins],
  components: {
    setWatermarkDialog,
  },
  data() {
    return {
      materialcontent: "", //富文本编辑器内容
      watermark: [""],
      saveflag: false,
      detailForm: { ...this.dialogForm },
      tableKey: Math.random(),
      totalPricetableList: [
        {
          id: 0,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 1,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 2,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 3,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 4,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 5,
          column0: "",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 2000,
          column0: "",
          column1: "合计（暂定）",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 2001,
          column0: "",
          column1: "含税总价：大写（暂定）（不含税价：      税率：    税金：）",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
      ], //中间表格数据
      inputPages: "",
      inputHeight: 1010,
      inputPosx: 37,
    };
  },
  methods: {
    addItem() {
      let len = this.totalPricetableList.length - 3;
      let id = (this.totalPricetableList[len]?.id ?? 0) + 1;
      let item = {
        id: id,
        column0: "",
        column1: "",
        column2: "",
        column3: "",
        column4: "",
        column5: "",
        column6: "",
        column7: "",
      };
      this.totalPricetableList.splice(len + 1, 0, item);
    },
    delItem() {
      if (this.totalPricetableList.length > 2) {
        // const table = this.$refs.onlyPriceTable;
        // this.totalPricetableList = getTableData(table, this.totalPricetableList, 8);
        this.totalPricetableList.splice(this.totalPricetableList.length - 3, 1);
        // this.tableKey=Math.random();
      }
    },
    //获取一条劳务合同信息
    getsubServiceContractDetail(id) {
      if (!id) return;
      let param = {};
      param.id = id;
      getServiceContractDetailService(param)
        .then((res) => {
          if (res.code == 10000000) {
            let data = {};
            if (res.data.subContractPrintVO) {
              data = res.data.subContractPrintVO;
              this.watermark = res.data.subContractPrintVO.watermark || [""];
              if (data.content) {
                this.saveflag = true;
                this.detailForm = JSON.parse(data.content);
                if (this.detailForm.addItems2) {
                  this.detailForm.addItems1 =
                    this.detailForm.addItems1 +
                    this.detailForm.addItems2 +
                    (this.detailForm.addItems3 || "") +
                    (this.detailForm.addItems4 || "") +
                    (this.detailForm.addItems5 || "");
                }

                if (this.detailForm.matrailsNeed2) {
                  this.detailForm.matrailsNeed1 =
                    this.detailForm.matrailsNeed1 +
                    this.detailForm.matrailsNeed2 +
                    (this.detailForm.matrailsNeed3 || "") +
                    (this.detailForm.matrailsNeed4 || "") +
                    (this.detailForm.matrailsNeed5 || "");
                }
                if (this.detailForm.fk2) {
                  this.detailForm.fk1 =
                    this.detailForm.fk1 +
                    this.detailForm.fk2 +
                    (this.detailForm.fk3 || "") +
                    (this.detailForm.fk4 || "") +
                    (this.detailForm.fk5 || "");
                }
                if (this.detailForm.contidion2) {
                  this.detailForm.contidion1 =
                    this.detailForm.contidion1 + this.detailForm.contidion2;
                }
                if (this.detailForm.slys2) {
                  this.detailForm.slys1 =
                    this.detailForm.slys1 + this.detailForm.slys2;
                }
                if (this.detailForm.totalPricetableList) {
                  this.totalPricetableList = JSON.parse(
                    this.detailForm.totalPricetableList
                  );
                  this.totalPricetableList.forEach((item, index) => {
                    if (index == this.totalPricetableList.length - 2) {
                      item.id = 2000;
                    } else if (index == this.totalPricetableList.length - 1) {
                      item.id = 2001;
                    } else {
                      item.id = index + 1;
                    }
                    return item;
                  });
                }
              } else {
                this.detailForm = { ...this.dialogForm };
                this.totalPricetableList = [
                  {
                    id: 0,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 1,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 2,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 3,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 4,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 5,
                    column0: "",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 2000,
                    column0: "",
                    column1: "合计（暂定）",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 2001,
                    column0: "",
                    column1:
                      "含税总价：大写（暂定）（不含税价：      税率：    税金：）",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                ];
              }
            }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
          this.loading=false;
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
          this.loading=false;
        });
    },
    /**
     * 关闭当前tab页面
     */
    closePage() {
      this.bus.$emit("tabClose", "order-detail");
    },
    ClosePrintOrder() {
      this.orderbillNo = [];
      this.orderDetailList = [];
    },
    saveContractA() {
      if (this.detailForm.approveStatus == 2) {
        this.$alert("合同为待审核无法修改", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      // this.getValues();
      const table = this.$refs.onlyPriceTable;
      this.totalPricetableList = getTableData(
        table,
        this.totalPricetableList,
        8
      );
      this.detailForm.totalPricetableList = JSON.stringify(
        this.totalPricetableList
      );
      this.tableKey = Math.random();
      if (this.detailForm.addItems2) {
        delete this.detailForm.addItems2;
        delete this.detailForm.addItems3;
        delete this.detailForm.addItems4;
        delete this.detailForm.addItems5;
      }

      if (this.detailForm.matrailsNeed2) {
        delete this.detailForm.matrailsNeed2;
        delete this.detailForm.matrailsNeed3;
        delete this.detailForm.matrailsNeed4;
        delete this.detailForm.matrailsNeed5;
      }
      if (this.detailForm.fk2) {
        delete this.detailForm.fk2;
        delete this.detailForm.fk3;
        delete this.detailForm.fk4;
        delete this.detailForm.fk5;
      }
      if (this.detailForm.contidion2) {
        delete this.detailForm.contidion2;
      }
      if (this.detailForm.slys2) {
        delete this.detailForm.slys2;
      }
      this.saveCommon('MaterialProcurementContract');
    },
    getValues() {
      // let Id = document.getElementById("HTMLMaterialContent");
      let Id = document.getElementsByClassName(this.printClass)[0];
      this.detailForm.serialNumber =
        Id.getElementsByClassName("serialNumber")[0].innerText;

      this.detailForm.partyA = Id.getElementsByClassName("partyA")[0].innerText;
      this.detailForm.partyB = Id.getElementsByClassName("partyB")[0].innerText;
      this.detailForm.projectName =
        Id.getElementsByClassName("projectName")[0].innerText;
      this.detailForm.signPlace =
        Id.getElementsByClassName("signPlace")[0].innerText;
      this.detailForm.signPlace1 =
        Id.getElementsByClassName("signPlace1")[0].innerText;

      this.detailForm.signDate1 =
        Id.getElementsByClassName("signDate1")[0].innerText;
      this.detailForm.signDate =
        Id.getElementsByClassName("signDate")[0].innerText;
      Id.getElementsByClassName("signDate")[0].innerHTML =
        this.detailForm.signDate;

      this.detailForm.project =
        Id.getElementsByClassName("project")[0].innerText; //发包人
      this.detailForm.projectTip =
        Id.getElementsByClassName("projectTip")[0].innerText; //施工总承包协议

      this.detailForm.addItems1 =
        Id.getElementsByClassName("addItems1")[0].innerText; //经营范围

      this.detailForm.matrailsNeed1 =
        Id.getElementsByClassName("matrailsNeed1")[0].innerText;

      this.detailForm.jainyan =
        Id.getElementsByClassName("jainyan")[0].innerText; //开工时间年
      this.detailForm.contidion1 =
        Id.getElementsByClassName("contidion1")[0].innerText;
      this.detailForm.zysj = Id.getElementsByClassName("zysj")[0].innerText; //交工时间年
      this.detailForm.ghsj = Id.getElementsByClassName("ghsj")[0].innerText; //交工时间月
      this.detailForm.xmssxc = Id.getElementsByClassName("xmssxc")[0].innerText; //交工时间日
      this.detailForm.slys1 = Id.getElementsByClassName("slys1")[0].innerText; //合同工期总日历天数为
      this.detailForm.timeAfterGet =
        Id.getElementsByClassName("timeAfterGet")[0].innerText; //含税总价小写
      this.detailForm.timeHandle =
        Id.getElementsByClassName("timeHandle")[0].innerText; //不含税价
      this.detailForm.others = Id.getElementsByClassName("others")[0].innerText; //税费
      this.detailForm.others1 =
        Id.getElementsByClassName("others1")[0].innerText; //税费
      this.detailForm.fk1 = Id.getElementsByClassName("fk1")[0].innerText; //合同订立地点
      this.detailForm.dbfs = Id.getElementsByClassName("dbfs")[0].innerText; //合同订立地点
      this.detailForm.days = Id.getElementsByClassName("days")[0].innerText; //合同订立地点
      this.detailForm.expenddays =
        Id.getElementsByClassName("expenddays")[0].innerText; //合同订立地点
      this.detailForm.contractHoleNums =
        Id.getElementsByClassName("contractHoleNums")[0].innerText; //合同订立地点
      this.detailForm.contractAnum =
        Id.getElementsByClassName("contractAnum")[0].innerText; //合同订立地点
      this.detailForm.contractBnum =
        Id.getElementsByClassName("contractBnum")[0].innerText; //合同订立地点

      Id.getElementsByClassName("signPlace")[0].innerHTML =
        this.detailForm.signPlace;
      Id.getElementsByClassName("serialNumber")[0].innerHTML =
        this.detailForm.serialNumber;
      Id.getElementsByClassName("signPlace1")[0].innerHTML =
        this.detailForm.signPlace1;
      Id.getElementsByClassName("signDate1")[0].innerHTML =
        this.detailForm.signDate1;
      Id.getElementsByClassName("project")[0].innerHTML =
        this.detailForm.project;
      Id.getElementsByClassName("projectTip")[0].innerHTML =
        this.detailForm.projectTip;
      Id.getElementsByClassName("addItems1")[0].innerHTML =
        this.detailForm.addItems1;
      Id.getElementsByClassName("matrailsNeed1")[0].innerHTML =
        this.detailForm.matrailsNeed1;
      Id.getElementsByClassName("jainyan")[0].innerHTML =
        this.detailForm.jainyan;
      Id.getElementsByClassName("contidion1")[0].innerHTML =
        this.detailForm.contidion1;
      Id.getElementsByClassName("zysj")[0].innerHTML = this.detailForm.zysj;
      Id.getElementsByClassName("ghsj")[0].innerHTML = this.detailForm.ghsj;
      Id.getElementsByClassName("xmssxc")[0].innerHTML = this.detailForm.xmssxc;
      Id.getElementsByClassName("xmssxc")[0].innerHTML = this.detailForm.xmssxc;
      Id.getElementsByClassName("slys1")[0].innerHTML = this.detailForm.slys1;
      Id.getElementsByClassName("timeAfterGet")[0].innerHTML =
        this.detailForm.timeAfterGet;
      Id.getElementsByClassName("timeHandle")[0].innerHTML =
        this.detailForm.timeHandle;
      Id.getElementsByClassName("others")[0].innerHTML = this.detailForm.others;
      Id.getElementsByClassName("others1")[0].innerHTML =
        this.detailForm.others1;
      Id.getElementsByClassName("fk1")[0].innerHTML = this.detailForm.fk1;
      Id.getElementsByClassName("dbfs")[0].innerHTML = this.detailForm.dbfs;
      Id.getElementsByClassName("days")[0].innerHTML = this.detailForm.days;
      Id.getElementsByClassName("expenddays")[0].innerHTML =
        this.detailForm.expenddays;
      Id.getElementsByClassName("contractHoleNums")[0].innerHTML =
        this.detailForm.contractHoleNums;
      Id.getElementsByClassName("contractAnum")[0].innerHTML =
        this.detailForm.contractAnum;
      Id.getElementsByClassName("contractBnum")[0].innerHTML =
        this.detailForm.contractBnum;

      this.detailForm.partA_gongzhang =
        Id.getElementsByClassName("partA_gongzhang")[0].innerText;
      Id.getElementsByClassName("partA_gongzhang")[0].innerHTML =
        this.detailForm.partA_gongzhang;
      this.detailForm.partA_sign =
        Id.getElementsByClassName("partA_sign")[0].innerText;
      Id.getElementsByClassName("partA_sign")[0].innerHTML =
        this.detailForm.partA_sign;
      this.detailForm.partA_phone =
        Id.getElementsByClassName("partA_phone")[0].innerText;
      Id.getElementsByClassName("partA_phone")[0].innerHTML =
        this.detailForm.partA_phone;
      this.detailForm.partA_account =
        Id.getElementsByClassName("partA_account")[0].innerText;
      Id.getElementsByClassName("partA_account")[0].innerHTML =
        this.detailForm.partA_account;
      this.detailForm.partA_ads =
        Id.getElementsByClassName("partA_ads")[0].innerText;
      Id.getElementsByClassName("partA_ads")[0].innerHTML =
        this.detailForm.partA_ads;
      this.detailForm.partA_fix =
        Id.getElementsByClassName("partA_fix")[0].innerText;
      Id.getElementsByClassName("partA_fix")[0].innerHTML =
        this.detailForm.partA_fix;

      this.detailForm.partB_gongzhang =
        Id.getElementsByClassName("partB_gongzhang")[0].innerText;
      Id.getElementsByClassName("partB_gongzhang")[0].innerHTML =
        this.detailForm.partB_gongzhang;
      this.detailForm.partB_sign =
        Id.getElementsByClassName("partB_sign")[0].innerText;
      Id.getElementsByClassName("partB_sign")[0].innerHTML =
        this.detailForm.partB_sign;
      this.detailForm.partB_phone =
        Id.getElementsByClassName("partB_phone")[0].innerText;
      Id.getElementsByClassName("partB_phone")[0].innerHTML =
        this.detailForm.partB_phone;
      this.detailForm.partB_ads =
        Id.getElementsByClassName("partB_ads")[0].innerText;
      Id.getElementsByClassName("partB_ads")[0].innerHTML =
        this.detailForm.partB_ads;

      this.detailForm.partB_fix =
        Id.getElementsByClassName("partB_fix")[0].innerText;
      Id.getElementsByClassName("partB_fix")[0].innerHTML =
        this.detailForm.partB_fix;
    },
    //打印当前合同
    PrintContractB() {
      if (this.dialogForm.approveStatus != 3) {
        this.$alert("合同尚未通过审核，无法打印", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      // let Id = document.getElementById("HTMLMaterialContent");
      let Id = document.getElementsByClassName(this.printClass)[0];
      let elementsToRemove = Id.querySelectorAll(".page-num");
      elementsToRemove.forEach(function (element) {
        element.parentNode.removeChild(element);
      });
      //addPageNum(Id, 1, "HTMLMaterialContent");
      addPageNumCustom(Id, 1, "HTMLMaterialContent", parseFloat(this.inputPages)+1, this.inputHeight, this.inputPosx);
      
      this.$set(
        this,
        "materialcontent",
        this.$refs.HTMLMaterialContent.innerHTML
      );

      this.$nextTick(() => {
        printJS({
          printable: "printMaterialcontent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
          style: `@page { size: auto;margin:10mm } p{line-height:31px;} .HTMLMaterialContent1 {background: url("data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='50%25' y='50%25' font-size='14' fill-opacity='0.3' text-anchor='middle' dominant-baseline='middle' transform='rotate(-35, 100 100)'%3E${this.watermark.join(
            ";"
          )}%3C/text%3E%3C/svg%3E");
}`,
        });
      });
    },
    //设置水印
    setWatermark() {
      this.$refs.setWatermarking.showwaterMarkDialog(
        this.subServiceContractId,
        this.watermark
      );
    },
    setWaterMarkFun(val) {
      this.watermark = val;
      let param = {
        warterMark: this.watermark,
        version: "1.0",
        flag: 2,
      };
      this.$emit("savePrintInfo", param);
    },
  },
};
</script>

<style>
#HTMLMaterialContent {
  box-sizing: border-box;
  box-shadow: 0px 4px 12px 2px #bbb;
  /* position: relative; */
  margin-top: 58px;
  padding: 0 10px;
  width: 20cm;
}
p {
  line-height: 31px;
}
.buttons {
  width: 22cm;
  height: 56px;
  position: fixed;
  top: 90px;
  background: white;
  z-index: 9;
}
.printWrap {
  width: 21cm;
  margin: 30px auto;
  padding: 5mm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.mainHtml {
  width: 21cm;
}
</style>
